<template>
  <div class="col d-flex justify-content-center">
    <div class="card">
      <div class="card-body">
        <h3 class="card-title">404</h3>
        <div class="col-12">
          <p>
            Page not found. The link you clicked may be broken or the page may have been removed.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
